import type { CustomerConfig } from '@/entities/customer-config';
import { FeatureFlag } from '@/types/feature-flag';

import { useMe } from './use-me';

// Define a reusable type for the feature flag function
export type FeatureFlagChecker = (
  flag: keyof CustomerConfig['featureFlags'],
) => boolean;

export function useFeatureFlag(): FeatureFlagChecker {
  const me = useMe();

  return function enableFeature(
    flag: keyof CustomerConfig['featureFlags'],
  ): boolean {
    const state = me.config.featureFlags[flag];

    switch (state) {
      case FeatureFlag.PUBLIC:
        return true;
      case FeatureFlag.INTERNAL:
        return me.isInternal;
      case FeatureFlag.DISABLED:
      default:
        return false;
    }
  };
}
